import React from 'react';
import { motion } from 'framer-motion';
import { FileDown, FileSpreadsheet, X } from 'lucide-react';
import { AudienceLevel, Cohort } from '../../types/pathway';
import { PathwayDocument } from './PathwayDocument';
import { PathwayButton } from './PathwayButton';
import { printPathwayDocument } from './PrintSurface';
interface DocumentViewerProps {
  open: boolean;
  pathwayName: string;
  company: string;
  cohort: Cohort | null;
  audience: AudienceLevel | 'any';
  items: string[];
  fields: string[];
  onClose: () => void;
  onDownloadCsv: () => void;
}
export function DocumentViewer({
  open,
  pathwayName,
  company,
  cohort,
  audience,
  items,
  fields,
  onClose,
  onDownloadCsv
}: DocumentViewerProps) {
  if (!open) return null;
  return <div className="fixed inset-0 z-[60] flex flex-col bg-gray-900/80" role="dialog" aria-modal="true" aria-labelledby="document-viewer-title" data-id="element-1534" data-mp="2705ikr2dkq04">
      <div className="flex flex-shrink-0 items-center justify-between gap-4 border-b border-gray-200 bg-white px-6 py-4" data-id="element-1535" data-mp="58ai77lkk7x7">
        <div className="min-w-0" data-id="element-1536" data-mp="2a3hyl0t3v3s1">
          <h2 id="document-viewer-title" className="truncate text-lg font-bold text-gray-900" data-id="element-1537" data-mp="2f3mfgrxxe0is">
            {pathwayName || 'Recommended Learning Pathway'}
          </h2>
          <p className="text-sm text-gray-600" data-id="element-1538" data-mp="2556lmh7ikd5l">
            Document preview · what the prospect receives
          </p>
        </div>
        <div className="flex flex-shrink-0 items-center gap-3" data-id="element-1539" data-mp="2swlqohqod8kj">
          <PathwayButton variant="secondary" size="sm" onClick={onDownloadCsv} className="min-w-0 px-4" data-id="element-1540" data-mp="2xux22wwmbr4v">
            <FileSpreadsheet size={16} data-id="element-1541" data-mp="2k0wb4pbwr8f2" />
            CSV
          </PathwayButton>
          <PathwayButton size="sm" onClick={() => printPathwayDocument(pathwayName)} data-id="element-1542" data-mp="2o30zp9ni1euu">
            <FileDown size={16} data-id="element-1543" data-mp="3bsbwkg1qap3p" />
            Save as PDF
          </PathwayButton>
          <button type="button" onClick={onClose} aria-label="Close preview" className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900" data-id="element-1544" data-mp="3gm6d5am1enyk">
            <X size={18} data-id="element-1545" data-mp="3hfx9v51io6rd" />
          </button>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex-1 overflow-auto p-8" data-id="element-1546" data-mp="3hia1yb0znxi5">
        <div className="mx-auto w-max" data-id="element-1547" data-mp="32ravp6nmll1q">
          <PathwayDocument pathwayName={pathwayName} company={company} cohort={cohort} audience={audience} items={items} fields={fields} data-id="element-1548" data-mp="32q856zu7tkmc" />
        </div>
      </motion.div>
    </div>;
}